import { Checkbox, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useSiteMutations } from "../../../../../hooks/useSiteMutations";
import { useSitesDetail } from "../../../../../hooks/useSitesDetail";
import { useToast } from "../../../../../mantine/notifications/useToast";
import { LoadOrError } from "../../../../LoadOrError/LoadOrError";

interface NoScadaProps {
  siteId: number;
}

function NoScada({ siteId }: NoScadaProps) {
  const { showErrorToast } = useToast();
  const [noScada, setNoScada] = useState(false);
  const {
    data: site,
    error: errorSite,
    isLoading: isSiteLoading
  } = useSitesDetail(siteId);

  const { updateMutation } = useSiteMutations(siteId);

  useEffect(() => {
    if (site) {
      setNoScada(site.no_scada);
    }
  }, [site]);

  function handleChangeNoScada(checked: boolean) {
    setNoScada(checked);
    if (site) {
      updateMutation
        .mutateAsync({
          ...site,
          no_scada: checked
        })
        .catch((error) => {
          showErrorToast(error);
          setNoScada(!checked);
        });
    }
  }

  return (
    <LoadOrError error={errorSite} loading={isSiteLoading}>
      <Checkbox
        checked={noScada}
        label={
          <>
            Ich wünsche, dass für diese Liegenschaft die Stromsteuermeldung OHNE
            Berücksichtigung von SCADA-Daten berechnet wird.
            <br />
            Achtung: Bei einer Berechnung ohne SCADA-Daten berücksichtigt
            opti.node automatisch die gesetzlich vorgegebenen
            Sicherheitsaufschläge.
          </>
        }
        onChange={(event) => handleChangeNoScada(event.currentTarget.checked)}
      />
    </LoadOrError>
  );
}

export { NoScada };
